import {h, Fragment} from "preact"
import { useAppStateSelector, useFacets, useProductFilters, pick } from "@nosto/preact"
import { useSidebarContext } from "../contexts/SidebarContext"
import { toggleFacets, visualFacets, nativePopularFilters, updateFacetsWithFilterTemplate } from "../config"

import Facet from "./facets/Facet"
import FacetToggle from "./facets/FacetToggle"
import FacetColors from "./facets/FacetColors"
import RangeFacet from "./facets/RangeFacet"
import VisualFacet from "./facets/VisualFacet"

export default function SideBar() {
    const { response } = useAppStateSelector(state => pick(state, "response"));
    let { loading, facets } = useFacets();
    const { removeAll } = useProductFilters();
    const { sidebarOpen, closeSidebar } = useSidebarContext();
    const docCount = response.products?.total ?? 0;

    let filterTemplateFacets = document.getElementById('filter-template-data') ?? null;
    if(filterTemplateFacets) {
        let newFilters = JSON.parse(filterTemplateFacets.dataset.filterTemplate);
        newFilters = newFilters.filters;
        let filteredFilters = updateFacetsWithFilterTemplate(facets, newFilters);
        if(filteredFilters) {
            facets = filteredFilters;
        }
    }
    

    return facets?.length > 0 && (
        <>
            <section
                id="ns-sidebar"
                class="ns-sidebar"
                aria-hidden={!sidebarOpen}
                aria-labelledby="sidebar-heading"
            >
                <div class="ns-sidebar-content grid grid-cols-1 lg:flex" style={(loading && window.innerWidth > 1024) ? "opacity: 0.4; pointer-events: none;" : ""}>
                    {/* header */}
                    <div class="ns-sidebar-header static lg:hidden bg-t-background !h3 text-t-foreground p-xs right-0 top-0 z-50 flex items-center justify-between bg-p-lightest lg:right-xs lg:top-xs">
                        <h5 
                            id="sidebar-heading" 
                            class="h5 flex-grow flex items-center flex-wrap"
                        >
                            Filters
                        </h5>
                        <button
                            class="ns-sidebar-close-btn focus-visible:ring-u-focus ml-auto inline-flex p-1 leading-none text-t-brand-primary focus:outline-none focus-visible:ring-1"
                            type="button"
                            aria-label="Close filters"
                            aria-controls="ns-sidebar"
                            aria-expanded={sidebarOpen}
                            onClick={closeSidebar}
                        >
                            <span class="block h-full w-full">
                                <svg fill="none" id="icon-close" viewBox="0 0 20 20" role="presentation">
                                    <path stroke="currentColor" d="M16.93 17.212 2.788 3.07M3.283 17.425 17.425 3.282"></path>
                                </svg>
                            </span>
                        </button>
                    </div>
                        {/* facets */}
                    <div class="ns-sidebar-body flex flex-col w-full">
                        <div class="ns-facet-list w-full flex-1 lg:mb-sm lg:border-x border-t-ui-lines-2 border-t text-t-foreground bg-t-background">
                            {facets?.map(facet => {
                                // if(nativePopularFilters.includes(facet.name)) return null;
                                const toggleData = toggleFacets.find(f => f.facetName === facet.name);
                                const visualFacet = visualFacets.find(vf => vf.facetField === facet.field);
                                if(toggleData) {
                                    return (
                                        <div key={facet.id} class="border-b border-t-ui-lines-2 px-sm py-lg md:py-md">
                                            <FacetToggle facet={facet} idPrefix="ns-sidebar" toggleData={toggleData} />
                                        </div>
                                    )
                                } else if (visualFacet) {
                                    return (
                                        <Fragment key={facet.id}>
                                            <VisualFacet facet={facet} />
                                            {(!visualFacet.hidden) && (
                                                <Facet facet={facet} />
                                            )}
                                        </Fragment>
                                    )
                                } else if (facet.name.toLowerCase() === 'lumber color') {
                                    return <FacetColors key={facet.id} facet={facet} />
                                } else if(facet.type === 'terms') {
                                    return <Facet key={facet.id} facet={facet} />
                                } else if(facet.type === 'stats') {
                                    return <RangeFacet key={facet.id} facet={facet} />
                                } else {
                                    return null;
                                }
                            })}
                        </div>

                        {/* footer */}
                        <div class="sticky lg:hidden bottom-0 w-full py-xs px-sm gap-xs grid grid-cols-[68%_30%] justify-center bg-t-background border-t border-t-ui-lines-2 border-solid">
                            <button 
                                class="btn !min-w-none"
                                variant="primary"
                                type="submit" 
                                aria-label="Apply selected filters"
                                onClick={(e) => {
                                    e.preventDefault();
                                    closeSidebar();
                                }}
                            >
                                Apply ({docCount})
                            </button>
                            <button
                                class="btn !min-w-none !border !border-t-foreground bg-t-brand-primary-contrast !px-xs"
                                variant="tertiary"
                                type="button"
                                aria-label="Clear all filters"
                                onClick={(e) => {
                                    e.preventDefault();
                                    removeAll();
                                    closeSidebar();
                                }}
                            >
                                Clear All
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <div
                class="ns-sidebar-backdrop lg:hidden"
                aria-label="Close filters list"
                aria-controls="ns-sidebar"
                role="button"
                tabIndex="0"
                aria-hidden={window.innerWidth >= 1024 || !sidebarOpen}
                onClick={closeSidebar}
            />
        </>
    )
}
